import React from 'react'
import { ColumnProps } from 'antd/lib/table'

import { Table } from 'src/components/Ant'

import { WrapTableDiv } from '../../styles'

export interface R8HeaderTableGeneric {
  name: string
  percent: string
  total: number
}

interface R8HeaderTableProps {
  columns: ColumnProps<R8HeaderTableGeneric>[]
  dataSource: R8HeaderTableGeneric[]
}

function R8HeaderTable({ columns, dataSource }: R8HeaderTableProps) {
  return (
    <WrapTableDiv>
      <Table
        className="table-sm"
        columns={columns}
        dataSource={dataSource}
        pagination={false}
      />
    </WrapTableDiv>
  )
}

export default R8HeaderTable
